module.exports = __webpack_public_path__ + "img/Calendar.feca861b.svg";